export const common = {
  nav: {
    home: 'Home',
    fleet: 'Our Fleet',
    weddings: 'Weddings',
    about: 'About Us',
    contact: 'Contact',
    policies: 'Policies',
    cart: 'Cart',
    vehiclesForSale: 'Vehicles for Sale'
  },
  hero: {
    title: 'Luxury Car Rental',
    titleLocation: 'Cancun and Miami',
    subtitle: 'Rent Ferrari, Lamborghini, McLaren and Porsche for weddings, events and VIP experiences. Premium 24/7 service with full insurance included. Available in Cancun, Tulum, Playa del Carmen and Miami.',
    viewFleet: 'View Exotic Car Fleet',
    reserveWhatsApp: 'Reserve via WhatsApp'
  },
  home: {
    brands: {
      title: 'Premium Brands',
      subtitle: 'of World Prestige'
    },
    featured: {
      title: 'Luxury Cars',
      titleHighlight: 'Available',
      subtitle: 'Discover our exclusive fleet of supercars and luxury SUVs for rent in Cancun, Tulum, Playa del Carmen and Miami',
      perDay: '/day',
      passengers: 'passengers',
      viewDetails: 'View Details and Prices',
      viewAll: 'View Complete Exotic Car Fleet'
    },
    forSale: {
      title: 'Vehicles',
      titleHighlight: 'for Sale',
      subtitle: 'Exclusive selection of premium and collectible vehicles available for purchase',
      forSale: 'FOR SALE',
      year: 'Year',
      moreInfo: 'MORE INFORMATION',
      viewAll: 'View All Vehicles for Sale',
      interested: 'Hello, I\'m interested in the'
    },
    whyChoose: {
      title: 'Why',
      titleHighlight: 'Rent with Us',
      feature1Title: 'Exclusive Premium Fleet',
      feature1Text: 'Only the most exclusive and best maintained vehicles: Ferrari, Lamborghini, McLaren, Porsche',
      feature2Title: 'Full Insurance Included',
      feature2Text: 'Complete coverage for your peace of mind throughout the entire rental experience',
      feature3Title: '24/7 Support',
      feature3Text: 'Assistance available at all times for any need during your rental',
      feature4Title: 'Multiple Locations',
      feature4Text: 'Available in Cancun, Tulum, Playa del Carmen, Miami and more exclusive destinations'
    },
    expansion: {
      title: 'Luxury Car Rental',
      titleHighlight: 'Now in the United States',
      text1: 'Now delivering in Florida — from Miami to the Keys, we bring the same power, prestige and luxury that made us famous in Mexico.',
      text2: 'Flying from Cancun to Miami? Your experience doesn\'t end at the airport. We\'ll have your dream car waiting for you — Ferrari, Lamborghini, McLaren, G-Wagon — all at your fingertips.',
      exploreFleet: 'Explore Complete Fleet',
      contactNow: 'Contact Now'
    },
    testimonials: {
      title: 'What Our',
      titleHighlight: 'Clients Say',
      testimonial1: 'An unforgettable experience. The Lamborghini Urus exceeded all my expectations. Impeccable service and exceptional attention to detail.',
      testimonial1Name: 'Carlos Mendoza',
      testimonial1Location: 'Mexico City',
      testimonial2: 'I rented the Ferrari Roma for my anniversary. It was the perfect gift. The team was very professional and the car was in perfect condition.',
      testimonial2Name: 'María González',
      testimonial2Location: 'Miami, FL',
      testimonial3: 'The McLaren 720S is a beast. The driving experience was incredible. I will definitely rent again with VIP Luxury Cars MKS.',
      testimonial3Name: 'Roberto Silva',
      testimonial3Location: 'Cancun, MX'
    },
    faq: {
      title: 'Frequently',
      titleHighlight: 'Asked Questions',
      q1: 'How much does it cost to rent a luxury car in Cancun?',
      a1: 'Prices vary by model. From $260 USD for 30 minutes to $5,200 USD for 24 hours for premium vehicles like the Ferrari Roma. We offer rental options for 30 min, 1h, 3h, 6h, 12h and 24h.',
      q2: 'What luxury car brands do you have available?',
      a2: 'We have Ferrari, Lamborghini, McLaren, Porsche, Mercedes-Benz G63 AMG, Range Rover and Cadillac Escalade. All our vehicles are recent models and in perfect condition.',
      q3: 'Does luxury car rental include insurance?',
      a3: 'Yes, all our rentals include full insurance for your peace of mind. We also offer 24/7 assistance throughout the entire rental period.',
      q4: 'Can I rent a luxury car for my wedding?',
      a4: 'Of course! We offer special wedding packages that include luxury vehicle rental and complimentary transfer within the hotel zone. Ideal for making your special day even more memorable.',
      q5: 'In which cities do you offer the rental service?',
      a5: 'We currently operate in Cancun, Tulum, Playa del Carmen (Mexico) and Miami, Florida (USA). We offer delivery at airports and hotels in these cities.'
    }
  },
  footer: {
    description: 'Premium luxury car rental in Cancun and Miami. Experience the thrill of driving the world\'s most exclusive vehicles.',
    quickLinks: 'Quick Links',
    contact: 'Contact',
    phone: 'Phone',
    email: 'Email',
    followUs: 'Follow Us',
    rights: 'All rights reserved',
    poweredBy: 'Website Builder',
    locations: 'Locations',
    cancun: 'Cancun, Quintana Roo, Mexico',
    miami: 'Miami, Florida, USA'
  },
  common: {
    perDay: 'per day',
    viewDetails: 'View Details',
    addToCart: 'Add to Cart',
    reserveNow: 'Reserve Now',
    contactUs: 'Contact Us',
    learnMore: 'Learn More',
    bookNow: 'Book Now',
    whatsapp: 'Reserve via WhatsApp',
    days: 'Days',
    total: 'Total',
    subtotal: 'Subtotal',
    remove: 'Remove',
    checkout: 'Checkout',
    continueShopping: 'Continue Shopping',
    emptyCart: 'Your cart is empty',
    features: 'Features',
    specifications: 'Specifications',
    passengers: 'Passengers',
    transmission: 'Transmission',
    fuel: 'Fuel',
    year: 'Year',
    includes: 'Includes',
    duration: 'Duration',
    hours: 'Hours',
    forSale: 'For Sale',
    requestInfo: 'Request More Information',
    price: 'Price',
    mileage: 'Mileage',
    owner: 'Owner',
    engine: 'Engine',
    horsepower: 'Horsepower',
    negotiable: 'Negotiable price'
  },
  fleet: {
    title: 'Our Exclusive Fleet',
    subtitle: 'Choose from the world\'s most prestigious luxury vehicles',
    filterAll: 'All',
    filterSupercar: 'Supercars',
    filterSUV: 'Luxury SUVs',
    filterSports: 'Sports Cars'
  },
  weddings: {
    title: 'Wedding Packages',
    subtitle: 'Make your special day unforgettable with our exclusive luxury vehicles',
    description: 'Exclusive wedding package with {vehicle}. Includes luxury vehicle rental and complimentary transfer within the hotel zone.',
    reserveWhatsApp: 'Reserve via WhatsApp',
    contactEmail: 'Contact via Email'
  },
  about: {
    title: 'About Sun & Speed',
    subtitle: 'Your Premier Luxury Car Rental Experience',
    mission: 'Our Mission',
    missionText: 'To provide an unparalleled luxury car rental experience, offering the world\'s most exclusive vehicles with exceptional service and attention to detail.',
    vision: 'Our Vision',
    visionText: 'To be the leading luxury car rental company in Mexico and the United States, recognized for our premium fleet and outstanding customer service.',
    values: 'Our Values',
    excellence: 'Excellence',
    excellenceText: 'We maintain the highest standards in vehicle maintenance and customer service.',
    trust: 'Trust',
    trustText: 'We build lasting relationships based on transparency and reliability.',
    passion: 'Passion',
    passionText: 'We share your passion for luxury automobiles and unforgettable experiences.',
    whyChoose: 'Why Choose Us',
    reason1: 'Premium Fleet',
    reason1Text: 'Access to the world\'s most exclusive luxury and exotic vehicles',
    reason2: '24/7 Service',
    reason2Text: 'Round-the-clock customer support and roadside assistance',
    reason3: 'Full Insurance',
    reason3Text: 'Comprehensive insurance coverage included with every rental',
    reason4: 'Flexible Delivery',
    reason4Text: 'Vehicle delivery and pickup at your preferred location'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Get in touch with us for reservations or inquiries',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone',
    message: 'Message',
    send: 'Send Message',
    info: 'Contact Information',
    location: 'Location',
    locationText: 'Cancun, Quintana Roo, Mexico',
    hours: 'Business Hours',
    hoursText: 'Monday - Sunday: 8:00 AM - 10:00 PM'
  },
  policies: {
    title: 'Rental Policies',
    subtitle: 'Important information about our rental terms and conditions',
    requirements: 'Rental Requirements',
    req1: 'Minimum age: 25 years',
    req2: 'Valid driver\'s license (minimum 2 years)',
    req3: 'Valid credit card in driver\'s name',
    req4: 'Passport or official ID',
    req5: 'Security deposit required',
    insurance: 'Insurance and Coverage',
    ins1: 'Full coverage insurance included',
    ins2: 'Collision damage waiver',
    ins3: 'Theft protection',
    ins4: 'Liability coverage',
    ins5: '24/7 roadside assistance',
    cancellation: 'Cancellation Policy',
    can1: 'Free cancellation up to 48 hours before pickup',
    can2: '50% refund for cancellations 24-48 hours before',
    can3: 'No refund for cancellations less than 24 hours',
    can4: 'Modifications subject to availability',
    terms: 'Terms and Conditions',
    term1: 'Fuel: Return with same fuel level',
    term2: 'Mileage: Unlimited within agreed area',
    term3: 'Additional drivers: $50 USD per day',
    term4: 'Late return: Charged at hourly rate',
    term5: 'No smoking in all vehicles',
    term6: 'No pets unless previously approved',
    rentalPolicy: 'Rental Policy',
    driverRequirements: 'Driver Requirements',
    minAge: 'Minimum age: 25 years',
    validLicense: 'Valid driver\'s license with at least 3 years of experience',
    officialId: 'Valid official ID (passport or government ID)',
    creditCard: 'Credit card in the main driver\'s name',
    proofAddress: 'Proof of address no older than 3 months',
    securityDeposit: 'Security Deposit',
    depositInfo: 'A refundable security deposit is required, varying by vehicle:',
    depositRange1: 'Vehicles up to $1,000/day: $5,000 USD',
    depositRange2: 'Vehicles $1,000 - $1,500/day: $10,000 USD',
    depositRange3: 'Vehicles $1,500+/day: $15,000 USD',
    depositRefund: 'The deposit is refunded within 7-14 business days after vehicle return, subject to inspection and no damages.',
    fuelPolicy: 'Fuel Policy',
    fuelInfo: 'All vehicles are delivered with a full tank and must be returned with a full tank. Otherwise, missing fuel will be charged plus a $50 USD service fee.',
    mileagePolicy: 'Mileage',
    mileageInfo: 'All our rentals include unlimited mileage within the agreed territory (Mexico or United States as applicable).',
    additionalDrivers: 'Additional Drivers',
    additionalDriversInfo: 'Additional drivers can be added for $25 USD per day. Each additional driver must meet the same requirements as the main driver and be present at vehicle pickup.',
    cancellationPolicy: 'Cancellation Policy',
    customerCancellation: 'Customer Cancellation',
    moreThan7Days: 'More than 7 days before',
    refund100: '100% refund of amount paid',
    between3And7Days: 'Between 3-7 days before',
    refund50: '50% refund of amount paid',
    lessThan3Days: 'Less than 3 days before',
    noRefund: 'No refund',
    reservationModifications: 'Reservation Modifications',
    modificationsInfo: 'Date modifications are subject to availability and may incur additional charges:',
    firstModification: 'First modification: No charge (more than 48 hours before)',
    additionalModifications: 'Additional modifications: $50 USD per change',
    vehicleChanges: 'Vehicle changes: Subject to price difference',
    noShow: 'No Show',
    noShowInfo: 'If the customer does not show up to pick up the vehicle without prior cancellation, there will be no refund of the amount paid.',
    privacyPolicy: 'Privacy Policy',
    informationCollection: 'Information Collection',
    collectionInfo: 'We collect the following personal information:',
    fullName: 'Full name, address and contact information',
    licenseInfo: 'Driver\'s license information',
    paymentInfo: 'Payment and billing information',
    rentalHistory: 'Rental history and preferences',
    informationUse: 'Use of Information',
    useInfo: 'We use your information to:',
    processReservations: 'Process and manage your reservations',
    communicate: 'Communicate with you about your rental',
    improveServices: 'Improve our services',
    sendOffers: 'Send offers and promotions (with your consent)',
    dataProtection: 'Data Protection',
    protectionInfo: 'We implement technical and organizational security measures to protect your personal information against unauthorized access, loss or alteration. All payment data is processed through secure and encrypted payment gateways.',
    yourRights: 'Your Rights',
    rightsInfo: 'You have the right to:',
    accessInfo: 'Access your personal information',
    correctData: 'Request correction of inaccurate data',
    deleteData: 'Request deletion of your data',
    objectProcessing: 'Object to the processing of your data',
    termsAndConditions: 'Terms and Conditions',
    lesseeResponsibility: 'Lessee Responsibility',
    maintainVehicle: 'Maintain the vehicle in good condition',
    complyLaws: 'Comply with all traffic laws',
    noDriving: 'Do not drive under the influence of alcohol or drugs',
    noRacing: 'Do not participate in races or competitions',
    noSublet: 'Do not sublet the vehicle',
    prohibitedUse: 'Prohibited Use',
    prohibitedInfo: 'The vehicle may NOT be used for:',
    commercialTransport: 'Commercial or passenger transport',
    towingVehicles: 'Towing other vehicles',
    unpavedRoads: 'Driving on unpaved roads',
    illegalActivities: 'Illegal activities',
    crossingBorders: 'Crossing international borders without authorization',
    damagesAndAccidents: 'Damages and Accidents',
    accidentInfo: 'In case of accident or damage to the vehicle:',
    notifyImmediately: 'Notify Sun & Speed immediately (24/7)',
    policeReport: 'Obtain a police report if necessary',
    noAdmitFault: 'Do not admit fault at the scene',
    documentIncident: 'Document the incident with photos',
    completeReport: 'Complete the provided accident report',
    finesAndViolations: 'Fines and Violations',
    finesInfo: 'The lessee is responsible for all fines, traffic violations, tolls and parking charges incurred during the rental period. An administrative fee of $50 USD will be charged for each processed violation.',
    vehicleReturn: 'Vehicle Return',
    returnInfo: 'The vehicle must be returned:',
    agreedDateTime: 'On the agreed date and time',
    specifiedLocation: 'At the specified location',
    fullTank: 'With a full fuel tank',
    sameCondition: 'In the same condition as delivered',
    lateReturn: 'Late returns will be charged at $100 USD per hour of delay.',
    insuranceAndWarranties: 'Insurance and Warranties',
    includedCoverage: 'Included Coverage',
    coverageInfo: 'All our rentals include:',
    liabilityInsurance: 'Liability insurance ($1,000,000 USD)',
    collisionDamage: 'Collision damage waiver (CDW)',
    theftProtection: 'Theft protection',
    roadsideAssistance: '24/7 roadside assistance',
    deductible: 'Deductible',
    deductibleInfo: 'In case of damage or theft, the lessee is responsible for the deductible:',
    minorDamages: 'Minor damages: $2,500 USD',
    majorDamages: 'Major damages: $5,000 USD',
    totalLoss: 'Total loss or theft: $10,000 USD',
    optionalCoverage: 'Optional Additional Coverage',
    premiumProtection: 'Premium Protection (Zero Deductible)',
    premiumInfo: 'Completely eliminates the deductible in case of damages',
    premiumPrice: '$75 USD per day',
    tireGlass: 'Tire and Glass Insurance',
    tireGlassInfo: 'Covers damage to tires, rims and glass',
    tireGlassPrice: '$25 USD per day',
    personalEffects: 'Personal Effects Protection',
    personalEffectsInfo: 'Covers loss or theft of personal belongings',
    personalEffectsPrice: '$15 USD per day',
    exclusions: 'Exclusions',
    exclusionsInfo: 'Insurance does NOT cover:',
    recklessDriving: 'Damage caused by reckless or negligent driving',
    underInfluence: 'Damage under the influence of alcohol or drugs',
    unauthorizedUse: 'Unauthorized use of the vehicle',
    intentionalDamage: 'Intentional damage',
    lostKeys: 'Loss of keys or documents',
    haveQuestions: 'Have Questions?',
    questionsInfo: 'Our team is available 24/7 to help you with any questions',
    contactButton: 'Contact Us',
    whatsappButton: 'WhatsApp'
  },
  cart: {
    title: 'Your Reservation',
    empty: 'Your cart is empty',
    emptyText: 'Add vehicles to your cart to start your reservation',
    vehicle: 'Vehicle',
    rental: 'Rental Period',
    price: 'Price',
    actions: 'Actions',
    summary: 'Reservation Summary',
    subtotal: 'Subtotal',
    tax: 'VAT (16%)',
    total: 'Total',
    checkout: 'Proceed to Payment',
    continue: 'Continue Browsing'
  },
  checkout: {
    title: 'Complete Your Reservation',
    subtitle: 'Choose your preferred payment method',
    personal: 'Personal Information',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email Address',
    phone: 'Phone Number',
    address: 'Address',
    city: 'City',
    state: 'State',
    zipCode: 'ZIP Code',
    country: 'Country',
    license: 'Driver License Information',
    licenseNumber: 'License Number',
    licenseExpiry: 'Expiration Date',
    payment: 'Payment Method',
    mercadopago: 'MercadoPago',
    paypal: 'PayPal',
    bitcoin: 'Bitcoin',
    selectPayment: 'Select a payment method',
    summary: 'Reservation Summary',
    vehicle: 'Vehicle',
    days: 'days',
    subtotal: 'Subtotal',
    tax: 'Tax (16%)',
    total: 'Total',
    payWith: 'Pay with',
    processing: 'Processing payment...',
    success: 'Payment Successful!',
    successMessage: 'Your reservation has been confirmed. We will contact you shortly.',
    error: 'Payment Error',
    errorMessage: 'There was an error processing your payment. Please try again.',
    close: 'Close',
    completeFields: 'Please complete all required fields',
    validLicense: 'Please enter a valid license expiration date'
  },
  vehiclesForSale: {
    title: 'Vehicles for Sale',
    subtitle: 'Discover our exclusive selection of premium vehicles available for purchase',
    comingSoon: 'Coming Soon',
    comingSoonText: 'Soon, this platform will feature a curated selection of premium vehicles for sale, including some of the most prestigious brands in the world.',
    exploreRentals: 'Explore Our Rental Fleet'
  }
};